const APIS = {
  USER: "/usermanagementservice/api/user/",
  USER_PROFILE: "logisticservice/api/user-profile/",
  CHANGE_PASSWORD: "/usermanagementservice/api/user/change-password/",
  LOGIN_HISTORY: "/usermanagementservice/api/login-history/",
};
export default APIS;
